const gql = String.raw;

export const RepairOrderFragment = gql`
	fragment RepairOrder on RepairOrder {
		_id
		finishDate
		employeeId
		employeeName
		department
		repairOrderNo
		operationCode
		startTime
		finishTime
		reason
		actualTime
		bookedTime
		bonusTime
		jobStatus
		rate
		extended
		extendedBonus
		job
		isParent
		payrollStatus
		hierarchy
		saleType
	}
`;
